import React from "react";

export const ZoomIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.375 21.375C17.3456 21.375 21.375 17.3456 21.375 12.375C21.375 7.40444 17.3456 3.375 12.375 3.375C7.40444 3.375 3.375 7.40444 3.375 12.375C3.375 17.3456 7.40444 21.375 12.375 21.375Z"
        stroke="#8798B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6242 23.6252L18.7305 18.7314"
        stroke="#8798B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
